import { useAppDispatch, useAppSelector } from "@/lib/store";
import { useEffect, useState } from "react";
import { fetchClientDetail, fetchClientProperties } from "./clients-detail.slice";
import { uuid } from "@/interfaces";
import { CustomerContactFormValues } from "../clients/clients.entity";
import { updateContact } from "./clients-detail.api";
import { toastError, toastSuccess } from "@/lib/utils";

export default function useClientsDetail(id: uuid) {
  const dispatch = useAppDispatch();
  const { data, loading, error, properties, propertiesLoading } = useAppSelector((s) => s.clientsDetail);

  const [editingModalOpen, setEditingModalOpen] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(fetchClientDetail(id));
      dispatch(fetchClientProperties(id));
    }
  }, [id, dispatch]);

  async function updateClientContact(contact: CustomerContactFormValues) {
    try {
      await updateContact(id, contact);
      setEditingModalOpen(false);
      toastSuccess("Client contact updated successfully");
      dispatch(fetchClientDetail(id));
    } catch (err) {
      toastError(err instanceof Error ? err.message : "Failed to update client contact");
    }
  }

  return {
    data,
    loading,
    error,
    refetch: () => dispatch(fetchClientDetail(id)),
    properties,
    propertiesLoading,
    editingModalOpen,
    setEditingModalOpen,
    onSubmit: updateClientContact,
  };
}
